import { COCP_TO_RETAIL_LAYOUT } from "../constants/AppConstants";


const NON_SERVICEABILITY_MODAL_PAGE_NAME = 'pincodeErrorModal'

export const checkPrepaidServiceability = ({ args, onUserAction, getState }: any) => {
    const { storeValues } = getState();

    const isPrepaidSKYC =  storeValues?.pincodeContext?.pincodeDetails?.serviceabilityMap?.Prepaid_SKYC ?? false
    const isPostpaidServiceable = storeValues?.pincodeContext?.pincodeDetails?.serviceabilityMap?.Postpaid_Online ?? false
    const layout = storeValues?.journeyContext?.layout
    const isCocpLayout = layout === COCP_TO_RETAIL_LAYOUT

    if (isPrepaidSKYC || (isCocpLayout && isPostpaidServiceable)) {

        //TODO - clean up to be done later - removed tat and cutofftime from omni
        // const rawTAT =  storeValues?.pincodeContext?.pincodeDetails?.TAT
        // const TAT = Number(String(rawTAT).trim());
        // const cutoffTime =  storeValues?.pincodeContext?.pincodeDetails?.cutoffTime;
        // const pincode =  storeValues?.pincodeContext?.pincodeDetails?.pincode;
        const latitude =  storeValues?.pincodeContext?.pincodeDetails?.latitude;
        const longitude =  storeValues?.pincodeContext?.pincodeDetails?.longitude;
        const trimmedLat: string = parseFloat(latitude)?.toFixed(3)?.toString();
        const trimmedLong: string = parseFloat(longitude)?.toFixed(3)?.toString();

        // let subHeading = pincode || "";

        // if (cutoffTime && !isNaN(TAT)) {

        //     const [cutoffHour, cutoffMinute] = cutoffTime.split(":").map(Number);
          
        //     let deliveryDate = new Date();
          
        //     deliveryDate.setDate(deliveryDate.getDate() + TAT);
          
        //     // if cutoffTime >= 11:00 → +1 day
        //     if (cutoffHour > 11 || (cutoffHour === 11 && cutoffMinute >= 0)) {
        //       deliveryDate.setDate(deliveryDate.getDate() + 1);
        //     }
          
        //     let formattedDate = deliveryDate.toLocaleDateString("en-GB", {
        //         day: "2-digit",
        //         month: "short",
        //         year: "numeric",
        //       });
              
        //       // Convert first letter to uppercase
        //       formattedDate = formattedDate.replace(
        //         /\b([a-z]{3})\b/,
        //         (match) => match.charAt(0).toUpperCase() + match.slice(1)
        //       );
        //     // TODO - Commented for now - for delhi and gurgoan circle  added hardcoded text
        //     // subHeading = `${pincode} • Delivery by ${formattedDate}`;
        //     subHeading = `${pincode} • Delivery by next working day` ;
        //   }

        //call update cart with milestone ADDRESS
        return onUserAction({
            actions: [
                {
                    "type": "apiCall",
                    "payload": {
                        "requestType": "POST",
                        "apiUrl": "guardian/api/skyc/prepaid/updateCart/v1",
                        "authTokenGroup": "SKYC_REVERIFICATION",
                        "queryParams": {},
                        "body": {
                            "data": {
                                ...(isCocpLayout && { layout: "cocp_to_retail" }),
                                "serviceSelected": "{{storeValues:appData.lob}}",
                                "orderSubType": "{{storeValues:appData.orderSubType}}",
                                "contactMedium": [
                                    {
                                        "mediumType": "alternateNumber",
                                        "characteristic": {
                                            "phoneNumber": "{{storeValues:appData.msisdn}}"
                                        }
                                    }
                                ],
                                "milestone": isCocpLayout ? "ADDRESS_COCP" : "ADDRESS",
                                "channel": [
                                    {
                                        "name": "SHOP"
                                    }
                                ],
                                "id": "{{storeValues:orderData.cartId}}",
                                "cartItem": [
                                    {
                                        "contactMedium": [
                                            {
                                                "mediumType": "billingAddress",
                                                "characteristic": {
                                                    "city": "{{storeValues:pincodeContext.pincodeDetails.city}}",
                                                    "postCode": "{{storeValues:pincodeContext.pincodeDetails.pincode}}",
                                                    "stateOrProvince": "{{storeValues:pincodeContext.pincodeDetails.state}}",
                                                    "street1": "{{storeValues:pincodeContext.pincodeDetails.addressString}}",
                                                    "country": "india"
                                                }
                                            }
                                        ],
                                        "product": {
                                            "productCharacteristic": [
                                                {
                                                    "name": "uniqueReferenceId",
                                                    "value": {
                                                        "textValue": "1771436056029"
                                                    }
                                                },
                                                {
                                                    "name": "productType",
                                                    "value": {
                                                        "textValue": "{{storeValues:appData.lob}}"
                                                    }
                                                },
                                                {
                                                    "name": "orderSubType",
                                                    "value": {
                                                        "textValue": "{{storeValues:appData.orderSubType}}"
                                                    }
                                                },
                                                {
                                                    "name": "acquisitionType",
                                                    "value": {
                                                        "textValue": "SKYC"
                                                    }
                                                },
                                                {
                                                    "name": "circleName",
                                                    "valueType": "textValue",
                                                    "value": {
                                                        "textValue": "{{storeValues:pincodeContext.pincodeDetails.circleCode}}"
                                                    }
                                                },
                                                {
                                                    "name": "circleId",
                                                    "valueType": "textValue",
                                                    "value": {
                                                        "textValue": "{{storeValues:pincodeContext.pincodeDetails.circleId}}"
                                                    }
                                                },
                                                {
                                                    "name": "latitude",
                                                    "valueType": "textValue",
                                                    "value": {
                                                        "textValue": trimmedLat
                                                    }
                                                },
                                                {
                                                    "name": "longitude",
                                                    "valueType": "textValue",
                                                    "value": {
                                                        "textValue": trimmedLong
                                                    }
                                                },
                                                {
                                                    "name": "partnerName",
                                                    "valueType": "textValue",
                                                    "value": {
                                                        "textValue": "{{storeValues:pincodeContext.pincodeDetails.partnerName}}"
                                                    }
                                                }
                                            ],
                                            "realizingResource": []
                                        },
                                        "quantity": 1,
                                        "action": isCocpLayout ? "modify" : "add",
                                        "id": "{{storeValues:orderData.cartItemId}}"
                                    }
                                ]
                            }
                        },
                    },
                },
                {
                    "payload": {
                        "context": "pincodeContext",
                        "data": {
                            "pincodeDetails.latitude": trimmedLat,
                            "pincodeDetails.longitude": trimmedLong,
                        }
                    },
                    "type": "storeValuesInRedux"
                }
            ],
        });
    } else {
        return onUserAction({
            actions: [
                {
                    payload: {
                        eventData: {
                            omniWidgetEvent: {
                                eventName: "CtoWCloseModal",
                                eventType: "closeAddressForm"
                            }
                        },
                        eventName: "addressWidget"
                    },
                    type: "nativeEventEmitter",
                },
                {
                    payload: {
                        modalData: {
                            "animationDuration": 220,
                            "showCross": true,
                            "showSubTitle": false,
                            "showHeaderTitle": false,
                            "closeOnPressMask": false,
                            "containerStyle": {},
                            "width": 392,
                            "swipeEnabled": false,
                            "minDistanceToCloseRatio": 0.2,
                            "maxWidth": 392,
                            "height": "auto"
                        },
                        modalSection: NON_SERVICEABILITY_MODAL_PAGE_NAME
                    },
                    "type": "openModal"
                }
            ],
        });
    }
};
